import { NAVBAR } from 'composer-blocks/lib/constants/BlockTypes';
import * as contentTypes from 'composer-blocks/lib/constants/ContentTypes';

export default {
  id: 'navbar_12',
  type: NAVBAR,
  name: 'Navbar 12',
  thumbnail: 'https://eventtia-composer.s3.amazonaws.com/assets/images/thumbnails/navbar/navbar_12.png',
  rootContent: {
    type: contentTypes.NAVBAR,
    properties: {
      backgroundColor: {type: 'css', value: '#8D7860', editable: true},
      color: {type: 'css', value: '#FFFFFF', editable: true},
      padding: {type: 'css', value: '0.5rem 1rem'},
      fontSize: {type: 'css', value: 'small', editable: true},
      logoSrc: {type: 'custom', value: '', editable: true},
      logoHeight: {type: 'custom', value: '3.5rem'},
      navItemFont: {type: 'custom', value: '\'Raleway\', sans-serif;'},
      navItemFontWeight: {type: 'custom', value: '500'},
      navItemHoverBorder: {type: 'custom', value: '#dbc4ab', editable: true},
      navItemActiveBackground: {type: 'custom', value: '#FFFFFF'},
      navItemPadding: {type: 'custom', value: '0.5rem 0.5rem'},
      navItemHoverTextColor: {type: 'custom', value: '#EEEEEE'},
      navItemActiveTextColor: {type: 'custom', value: '#8D7860', editable: true},
      socialMedia: {type: 'custom', value: true, editable: true},
      facebookLink: {type: 'custom', value: 'facebook.com', editable: true},
      twitterLink: {type: 'custom', value: 'twitter.com', editable: true},
      linkedInLink: {type: 'custom', value: 'linkedin.com', editable: true},
      instagramLink: {type: 'custom', value: 'instagram.com', editable: true},
      socialMediaIconColor: {type: 'custom', value: '#FFFFFF', editable: true}

    },
    contents: []
  }
}
